import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Wine } from "lucide-react";

export function TriggerCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/insights/triggers").then(({ data }) => setData(data)).catch(() => setData({ triggers: [], message: "Couldn't load triggers just now." }));
  }, []);

  return (
    <div className="mt-6 card-paper p-6 sm:p-8" data-testid="insights-triggers-card">
      <div className="flex items-center gap-2">
        <Wine size={18} className="text-[#5F7463]" />
        <h2 className="font-serif-display text-2xl text-[#2C221E]">What comes before the harder days</h2>
      </div>
      <p className="mt-1 text-sm text-[#73635B]">
        Each tag compared against the day that followed it. Observations, not verdicts.
      </p>
      {!data ? (
        <p className="mt-5 text-sm text-[#8C7A70]">one moment…</p>
      ) : data.triggers.length === 0 ? (
        <p className="mt-5 text-[#52443E] leading-relaxed" data-testid="insights-triggers-empty">{data.message}</p>
      ) : (
        <ul className="mt-5 grid sm:grid-cols-2 gap-4">
          {data.triggers.map((t) => (
            <li key={t.trigger} className="rounded-2xl border border-[#E5D9C8] bg-[#FFFDF9] p-5" data-testid={`insights-trigger-${t.trigger}`}>
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-serif-display text-lg text-[#2C221E]">{t.label}</h3>
                <span className="text-xs uppercase tracking-widest text-[#8C7A70] font-semibold">
                  {t.count} {t.count === 1 ? "day" : "days"}
                </span>
              </div>
              <ul className="mt-3 space-y-1.5">
                {t.findings.map((f, i) => (
                  <li key={i} className="text-sm text-[#52443E] leading-relaxed">
                    <span className="text-[#5F7463] mr-2">—</span>{f}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
